<template>
  <div class="column">
    <div class="columns">
      <div class="column">
        <div class="list-view has-background-white p-3 is-border-radius-sm card-tab-details">
          <table-toolbar searchPlaceHolder="Search Locations" :toolbarOpts="tableColOpts.toolBar"
            @handleAction="handleAction" />
          <data-table :apiMode="true" :tableOpts="tableColOpts" :loadData="loadData" @cell-clicked="handleAction"
            :key="refreshTable" />
        </div>
        <location-form v-if="showCreateEditModal" :isActive="showCreateEditModal" @close="updateTable"
          :project="project" :editMode="editMode" :rowToEdit="rowToEdit" />
        <o-modal v-if="showDelOrCopyModal" :active="showDelOrCopyModal" :canCancel="false" class='modal-md'>
          <div class="modal-card">
            <header class="modal-card-head is-borderless">
              <h3 class="card-header-title p-0 has-text-black-bis">
                {{ !importMode ? 'Replace Location' : 'Import Company Locations' }}
              </h3>
            </header>
            <section class="modal-card-body is-visible has-text-black-bis card-tab-details">
              <div class="column" v-if="importMode">
                <search-bar :shouldEmit="true" @search="searchModalData" placeholder="Search">
                </search-bar>
              </div>
              <div class="column" v-else>
                <div class="field">
                  <div class="field-label">
                    <label class="label"> Some orders may be using {{ rowToDelete.name }}. Please select a new location
                      for these orders. </label>
                  </div>
                </div>
              </div>
              <data-table :apiMode="true" :tableOpts="getOpts" :loadData="loadReplaceData"
                @checkbox-toggled="setSelectedRows" :checkableHeader="false"
                :singleSelection="!importMode && !$_.isEmpty(rowToDelete)" :key="refreshModalTable" />
            </section>
            <footer class="modal-card-foot is-justify-content-flex-end">
              <button class="button is-outlined" @click="
                showDelOrCopyModal = false;
                rowToDelete = {};
                importMode = false
                modalSearchVal = ''
                  ">
                Cancel
              </button>
              <button class="button has-background-black-bis" :disabled="!importMode ? $_.isEmpty(rowToDelete) : false"
                @click="handleAddReplace">
                {{ !importMode ? "Replace" : "Import" }}
              </button>
            </footer>
          </div>
          <o-loading :active="isLoading" :full-page="false" />
        </o-modal>
      </div>
    </div>
    <o-loading :active="isLoading" :full-page="false" />
  </div>
  <activity-log
      :id="activityDetail.id"
      :projectId="activityDetail.projectId"
      :isActive="isActivityLogOpen"
      :orderName="activityDetail.orderName"
      @update:isActive="isActivityLogOpen = false"
      :type = "module"
    ></activity-log>
</template>
<script>
import { computed, onBeforeMount, reactive, toRefs } from "vue";
import { useStore } from 'vuex';
import DataTable from "@/components/table-fields/DataTable.vue";
import TableToolbar from "@/components/table-fields/TableToolbar.vue";
import projectTeamCols from "@/components/table-cols/projectLocationCols.js";
import TableGutter from "@/components/TableGutter.vue";
import Location from '@/models/Locations';
import LocationForm from '@/components/modals/LocationsForm.vue'
import { useToast } from "vue-toastification";
import { each, filter, isEmpty } from 'lodash';
import SearchBar from '@/components/SearchBar.vue';
import Projects from "@/models/Projects";
import ActivityLog from '@/components/ActivityLog.vue';

export default {
  name: "Project Locations",
  components: {
    DataTable,
    TableToolbar,
    TableGutter,
    LocationForm,
    SearchBar,
    ActivityLog
  },
  props: {
    rowData: Object,
  },
  setup(props) {
    const toast = useToast();

    const data = reactive({
      tableColOpts: projectTeamCols,
      isLoading: false,
      showCreateEditModal: false,
      refreshTable: 0,
      editMode: false,
      rowToEdit: {},
      rowToDelete: {},
      showDelOrCopyModal: false,
      fallbackLocation: {},
      importMode: false,
      selectedRowsToImport: [],
      project: {},
      searchVal: '',
      modalSearchVal: '',
      refreshModalTable: 0,
      activityDetail: {
        id: '',
        projectId: '',
        orderName: '',
      },
      isActivityLogOpen: false,
    });

    const store = useStore();
    const isProjectAdmin = () => data.project.projectUsers?.find(
      (projectUser) => projectUser.user?._id === store.state.userData._id && projectUser.isAdmin
    ) || false;

    const loadData = async (commonParam, e) => {
      const params = {
        ...commonParam,
        sort: commonParam.sort[0].direction === 'asc' ? commonParam.sort[0].sortField : `-${commonParam.sort[0].sortField}`,
        companyId: store.state.userData.company,
        type: null,
        projectId: props.rowData._id,
        showOnlyCompany: false,
        searchText: data.searchVal
      };
      const responseData = await Location.allCompanyLocations(params);
      return responseData;
    }


    const setModalActive = (key, val) => {
      data[key] = val;
    };

    const setEdit = (row) => {
      data.editMode = true;
      data.rowToEdit = row;
      setModalActive('showCreateEditModal', true)
    }

    const removeLocation = async (row) => {
      if (data.project.projectLocations.length === 1) {
        toast.error('Cannot delete single location')
      } else {
        // this.locType = 'project_location';
        // this.removedLocation = opts.data;
        // this.deleteLocation = true;
        data.rowToDelete = row
        data.showDelOrCopyModal = true
      }
    }

    const searchData = (val) => {
      if ((!isEmpty(data.searchVal) && isEmpty(val)) || (!isEmpty(val) && data.searchVal !== val)) {
        data.searchVal = val
        data.refreshTable++;
      }
    }

    const handleAction = async (action) => {
      if (['importLocation', 'addNew', 'activity'].includes(action)) {
        const type = action
        action = { type: '' }
        action.type = type
      }
      const actionMapper = {
        addNew: () => setModalActive('showCreateEditModal', true),
        activity: () => {
          data.activityDetail = {
            id: props.rowData._id,
            projectId: props.rowData._id,
            orderName: props.rowData.name,
          };
          data.isActivityLogOpen = true;
        },
        edit: (row) =>  setEdit(row),
        delete: (row) => removeLocation(row),
        importLocation: () => {
          data.importMode = true
          setModalActive('showDelOrCopyModal', true)
        },
        search: (val) => searchData(val)
      }
      try {
        actionMapper[action.type]?.(action.data)
        data.isLoading = true
      } catch (e) {
        console.error('Error: ', e)
      } finally {
        data.isLoading = false
      }
    }

    onBeforeMount(async() => {
      data.project = _.cloneDeep(props.rowData)
      await store.getters.userPromise;
      await getProject()
    })

    const updateTable = (val) => {
      if (val?.added) {
        data.refreshTable++
      }
      data.editMode = false;
      data.rowToEdit = {};
      setModalActive('showCreateEditModal', false)
    }

    const getOpts = computed(() => {
      const opts = _.cloneDeep(projectTeamCols)
      opts.isCheckable = true
      opts.fields.pop()
      return opts
    })

    const loadReplaceData = async (commonParam) => {
      if (data.importMode) {
        const params = {
          ...commonParam,
          sort: { [commonParam.sort[0].sortField]: commonParam.sort[0].direction === 'asc' ? 1 : -1 },
          companyId: store.state.userData.company,
          type: null,
          projectId: props.rowData._id,
          type: 'company_location',
          hideRoot: true,
          searchText: data.modalSearchVal
        };
        const locations = await Location.allCompanyLocations(params);
        locations.data = filter(locations.data, (locs) => !locs.project.includes(props.rowData._id));
        return locations;
      } else {
        const allLocations = data.project.projectLocations
        const locs = filter(allLocations, (location) => {
          const locationOwnerCompany = location.company._id || location.company;
          const removedLocationOwnerCompany = data.rowToDelete.company._id
          return location._id !== data.rowToDelete._id
            && locationOwnerCompany === removedLocationOwnerCompany
            && !location.archived && !location.nestedLocation;
        });
        return { data: locs }
      }
    }

    const handleAddReplace = async () => {
      data.isLoading = true
      try {
        if (data.importMode) {
          const params = {
            location_ids: [],
            project_id: props.rowData._id,
          }
          each(data.selectedRowsToImport, (val) => {
            params.location_ids.push(val._id);
          });
          await Location.importLocation(params);
        } else if (!isEmpty(data.rowToDelete)) {
          if (!isProjectAdmin()) {
            throw new Error('Cannot remove locations: contact your Admin for permission');
          }

          await Location.deleteLocation({
            project_id: props.rowData._id,
            location_id: data.rowToDelete._id,
            fallback_location_id: data.fallbackLocation._id,
          });
          toast.success('Location deleted')
        }
      } catch (e) {
        console.log('Error: ', e)
        toast.error(e.message || 'Error removing location');
      } finally {
        data.rowToDelete = {}
        data.fallbackLocation = {}
        data.showDelOrCopyModal = false
        data.importMode = false 
        data.editMode = false
        data.selectedRowsToImport = []
        data.isLoading = false
        data.refreshTable++;
        await getProject()
      }
    }

    const setSelectedRows = (row) => {
      if (data.importMode) {
        data.selectedRowsToImport = row;
      } else if (!isEmpty(row)) {
        data.fallbackLocation = row[0]
      }
    }

    const getProject = async () => {
      data.project = await Projects.getOne(props.rowData._id);
    }

    const searchModalData = (val) => {
      if ((!isEmpty(data.modalSearchVal) && isEmpty(val)) || (!isEmpty(val) && data.modalSearchVal !== val)) {
        data.modalSearchVal = val
        data.refreshModalTable++;
      }
    }

    return {
      ...toRefs(data),
      loadData,
      handleAction,
      updateTable,
      getOpts,
      loadReplaceData,
      handleAddReplace,
      setSelectedRows,
      searchModalData
    };
  },
};
</script>